<template>
  <v-container fill-height fluid grid-list-sm>
    <v-layout>
      <v-flex md12 lg12>
        <HospedesAvulsosList />
      </v-flex>
      

    </v-layout>
  </v-container>
</template>
<script>
import HospedesAvulsosList from "./HospedesAvulsosList";
/* import uhs from './UHs' */
export default {
  components: {
    HospedesAvulsosList,
    /* uhs */
  },
  data: () => ({
 
    
  })
}

</script>